import { Box, Image } from '@core/component';
import { BLOG_IMAGE_HEIGHT, BLOG_IMAGE_WIDTH } from '@core/constant';
import { useContextMediaQuery } from '@core/context';
import { EFilenameBlur, getStaticPathImage, getStaticPathImageBlurData } from '@core/media';
import { urlFor } from '@core/sanity';
import { ImageObject } from '@core/type/sanity';

export const BlogArticleImage = ({ image, title }: { image: ImageObject; title: string }) => {
  const { isPhone } = useContextMediaQuery();

  return (
    <Box margin={isPhone ? '0 -20px' : '0'}>
      <Image
        src={urlFor(image) || getStaticPathImage('card/article-default.png')}
        alt={image?.alt ?? title}
        title={image?.title}
        width={BLOG_IMAGE_WIDTH}
        height={BLOG_IMAGE_HEIGHT}
        blurDataURL={getStaticPathImageBlurData(EFilenameBlur['card/article-default.png'])}
        style={{ width: '100%', height: 'auto' }}
        priority
      />
    </Box>
  );
};
